<div class="embed-container">
  <router-outlet></router-outlet>
  <div class="form-modal-container sm-z-50"></div>
  <div class="embed-toolbar">
    <div>
      <img class="embed-toolbar-logo" src="./assets/images/dashpivot-logo.png" />
    </div>
    <div class="embed-toolbar-tools">
      <span (click)="openLargeVersion()" class="embed-toolbar__tool"
        ><i class="fa fa-expand fa-fw"></i> View larger version</span
      >
    </div>
  </div>
</div>
